import { formatPrice } from "@/i18n";

/**
 * Renders a product price. When `originalRub` is provided and higher than
 * `priceRub`, shows the original with a strike-through and the selling price
 * prominently in red.
 */
export const PriceDisplay = ({
  priceRub,
  originalRub = 0,
  currency,
  priceClassName = "",
  originalClassName = "",
  testId,
}) => {
  const onSale = originalRub > 0 && originalRub > priceRub;

  if (!onSale) {
    return (
      <span className={priceClassName} data-testid={testId}>
        {formatPrice(priceRub, currency)}
      </span>
    );
  }

  return (
    <span className="inline-flex items-baseline gap-2 whitespace-nowrap" data-testid={testId}>
      <span className={`text-red-600 ${priceClassName}`} data-testid={testId ? `${testId}-selling` : undefined}>
        {formatPrice(priceRub, currency)}
      </span>
      <span className={`text-ink/40 line-through ${originalClassName}`} data-testid={testId ? `${testId}-original` : undefined}>
        {formatPrice(originalRub, currency)}
      </span>
    </span>
  );
};

export default PriceDisplay;
